<template>
    <div class="margin-bottom-24">
        <h5 class="d-flex align-items-center">
            {{ parentData['title_' + getLang()] }}
            {{ parentData.required ? '*' : '' }}

            <info-label
                v-if="parentData.settings && parentData.settings.tooltip"
                :text="parentData.settings.tooltip"
            />
        </h5>

        <div style="overflow-x: scroll">
            <input type="hidden" :name="parentData.code" v-model="getJson">
            <table class="table">
                <thead>
                <tr>
                    <th v-for="tableColumn in tableColumns" :key="tableColumn['title_' + getLang()] ">
                        <div class="d-flex align-items-center justify-content-between w-100">

                            <div class="d-flex align-items-center">
                                <a
                                    v-if="tableColumn.code === 'appraiser'"
                                    href="https://bagalau.dfo.kz/ru/b-information"
                                    target="_blank"
                                    class="text-white text-decoration-underline"
                                    style="color: white; text-decoration: underline;"
                                >
                                    {{ tableColumn['title_' + getLang()] }}
                                </a>

                                <span v-else>
                                    {{ tableColumn['title_' + getLang()] }}
                                </span>

                                <span class="ms-1">{{ tableColumn.required ? '*' : '' }}</span>
                            </div>

                            <info-label
                                v-if="tableColumn.settings && tableColumn.settings.tooltip"
                                :text="tableColumn.settings.tooltip"
                            />
                        </div>
                    </th>
                    <th v-show="tableRows.length > 1 && isEditible" class="hidden">
                        Действие
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, rowIndex) in tableRows" :key="rowIndex">
                    <td v-for="(tableColumn, index) in tableColumns" :key="index">
                        <fields
                            :field="tableColumn"
                            :old-data="row[tableColumn.code]"
                            :is-editable="isEditible"
                            :table-view="true"
                            @updateField="updateTableRow(rowIndex, tableColumn.code, $event)">
                        </fields>
                        <div v-if="validationErrors[parentData.code + '.' + rowIndex + '.' + tableColumn.code]">
                            <span
                                v-for="error in validationErrors[parentData.code + '.' + rowIndex + '.' + tableColumn.code]"
                                class="error-text d-block">{{ error }}</span>
                        </div>
                    </td>
                    <td v-show="tableRows.length > 1 && isEditible" class="border-none">
                        <button type="button" class="table-button alert-danger" @click="removeTableRow(rowIndex)">
                            {{
                                {
                                    ru: 'Удалить',
                                    kz: 'Жою',
                                    en: 'Remove',
                                }[getLang()]
                            }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <button type="button" v-if="isEditible" class="add-row margin-top-16 table-button" @click="addTableRow">
            + {{
                {
                    ru: 'Добавить строку',
                    kz: 'Жол қосу',
                    en: 'Add a line',
                }[getLang()]
            }}
        </button>
        <div v-if="parentData['note_' + getLang()]" class="table-note" v-html="parentData['note_' + getLang()]"></div>
    </div>
</template>

<script>
import {defineAsyncComponent} from 'vue';
import InfoLabel from '../ui/InfoLabel.vue';

export default {
    name: 'table-list',
    components: {
        InfoLabel,
        Fields: defineAsyncComponent(() => import('./Fields.vue')),
    },
    emits: ['input'],
    props: {
        table: [String, Array],
        oldData: String,
        tableCode: String,
        isEditible: Boolean,
        parentFieldData: Object,
        validationErrors: Object,
    },
    data() {
        return {
            tableColumns: [],
            tableRows: [],
            parentData: {},
        };
    },
    mounted() {
        if (typeof this.table === 'string') {
            try {
                this.tableColumns = JSON.parse(this.table);
            } catch (e) {
                this.tableColumns = [];
            }
        } else {
            this.tableColumns = this.table || [];
        }

        this.parentData = this.parentFieldData;

        if (!this.parentData.settings || Array.isArray(this.parentData.settings)) {
            this.parentData.settings = {};
        }

        if (this.oldData === '' || !this.oldData) {
            const minRows = (this.parentData.validation && this.parentData.validation.min) ? this.parentData.validation.min : 1;
            this.tableRows = Array.from({length: minRows}, () => this.createEmptyRow());
        } else {
            try {
                this.tableRows = JSON.parse(this.oldData);
            } catch (e) {
                this.tableRows = [];
            }
        }
        this.$emit('input', JSON.stringify(this.tableRows));
    },
    computed: {
        getJson() {
            return JSON.stringify(this.tableRows);
        },
    },
    methods: {
        getLang() {
            return document.querySelector('html').getAttribute('lang') || 'ru';
        },
        addTableRow() {
            this.tableRows.push(this.createEmptyRow());
            this.$emit('input', JSON.stringify(this.tableRows));
        },
        removeTableRow(index) {
            this.tableRows.splice(index, 1);
            this.$emit('input', JSON.stringify(this.tableRows));
        },
        createEmptyRow() {
            const emptyRow = {};
            this.tableColumns.forEach(item => {
                emptyRow[item.code] = '';
            });
            return emptyRow;
        },
        updateTableRow(rowIndex, columnCode, newValue) {
            this.tableRows[rowIndex][columnCode] = newValue;
            this.$emit('input', JSON.stringify(this.tableRows));
        },
    },
};
</script>

<style scoped>
table td {
    vertical-align : middle;
    padding        : 12px 16px;
}

.hidden {
    visibility : hidden;
    border     : none;
}

.border-none {
    border : none;
}

table thead th {
    vertical-align   : middle;
    background-color : #007A40;
    color            : #FFFFFF;
    font-size        : 14px;
    font-weight      : 600;
    line-height      : 17.12px;
    padding          : 12px 16px;
}

.add-row {
    color       : #007A40;
    font-size   : 14px;
    font-weight : 600;
    line-height : 17.12px;

    background  : none;
    border      : none;
}

.table-button {
    background : none;
    border     : none;
    padding    : 0;
}

.table-note {
    margin-top : 30px;
}

img {
    cursor : pointer;
}
</style>
